import { privateRequest } from "../axios";
import type { ApiResponse, ExportFileResult } from "@/types/common";
import { parseFilenameFromContentDisposition } from "@/lib/downloadExcel";
import type {
  CreateSupportPayload,
  GetSupportResponse,
  SupportItem,
  SupportQueryParams,
  UpdateSupportPayload,
} from "@/types/support";

const ENDPOINTS = {
  FAQS: "/faqs",
  FAQ_BY_ID: (id: string | number) => `/faqs/${id}`,
};

const getSupportItems = async (params?: SupportQueryParams): Promise<GetSupportResponse<SupportItem>> => {
  const response = await privateRequest.get<ApiResponse<GetSupportResponse<SupportItem>>>(ENDPOINTS.FAQS, {
    params,
  });
  return {
    totalRecord: response.data.data?.totalRecord ?? 0,
    results: response.data.data?.results ?? [],
  };
};

const createSupportItem = async (payload: CreateSupportPayload): Promise<ApiResponse<unknown>> => {
  const response = await privateRequest.post<ApiResponse<unknown>>(ENDPOINTS.FAQS, payload);
  return response.data;
};

const updateSupportItem = async (
  id: string | number,
  payload: UpdateSupportPayload,
): Promise<ApiResponse<unknown>> => {
  const response = await privateRequest.put<ApiResponse<unknown>>(ENDPOINTS.FAQ_BY_ID(id), payload);
  return response.data;
};

const deleteSupportItem = async (id: string | number): Promise<ApiResponse<unknown>> => {
  const response = await privateRequest.delete<ApiResponse<unknown>>(ENDPOINTS.FAQ_BY_ID(id));
  return response.data;
};

const exportSupportItems = async (params?: Pick<SupportQueryParams, "search">): Promise<ExportFileResult> => {
  const response = await privateRequest.get(ENDPOINTS.FAQS, {
    params: { ...params, isExport: true },
    responseType: "blob",
  });
  return {
    blob: response.data as Blob,
    fileName: parseFilenameFromContentDisposition(response.headers["content-disposition"]),
  };
};

const SupportService = {
  getSupportItems,
  createSupportItem,
  updateSupportItem,
  deleteSupportItem,
  exportSupportItems,
};

export default SupportService;
